<template>
    <div
        class="modal-overlay"
        @keyup.esc="closeModal()"
        @click="closeModal()"
        tabindex="0"
    >
        <div ref="container" class="modal-container" @click.stop tabindex="1">
            <keep-alive>
                <component
                    v-bind:is="currentTabComponent"
                    class="tab"
                    :value="val"
                    :updateFunction="updateFunction"
                    :list="list"
                    :listOthers="listOthers"
                    :pageTitle="pageTitle"
                ></component>
            </keep-alive>
        </div>
    </div>
</template>

<script>
import NovoTurno from '@/components/promotor/turnos/NovoTurno.vue';
import InfoHorario from '@/components/promotor/turnos/InfoHorario.vue';
import DuplicarDia from '@/components/promotor/rota/modal/DuplicarDia.vue';
import SelectLPS from '@/components/promotor/rota/modal/SelectLPS.vue';
import ModalVSelect from '@/components/shared/ModalVSelect.vue';
import ConfirmationWindow from '@/components/shared/ConfirmationWindow.vue';

export default {
    components: {
        NovoTurno,
        InfoHorario,
        ModalVSelect,
        DuplicarDia,
        SelectLPS,
        ConfirmationWindow
    },
    name: 'ModalContainer',
    props: {
        containerName: {
            default: 'NovoTurno',
        },
        val: {
            default: {},
        },
        updateFunction: {
            type: Function,
            default: () => {},
        },
        list: {
            type: Array,
            default: () => [],
        },
        listOthers: {
            type: Array,
            default: () => [],
        },
        pageTitle: {
            type: [Array, String],
            default: () => [],
        },
    },
    mounted() {},
    data() {
        return {
            loadthis: 0,
            currentTab: this.containerName,
            tabs: [
                'NovoTurno',
                'InfoHorario',
                'ListaAssociativa',
                'ModalVSelect',
                'DuplicarDia',
                'SelectLPS',
                'ConfirmationWindow', // Trocado em favor do confirm() do buefy, chamado por this.$root.confirm()
            ],
            onclose: null,
        };
    },
    computed: {
        currentTabComponent: function () {
            return this.currentTab;
        },
    },
    created() {
        this.currentTab == this.containerName;
        this.$nextTick(() => this.$refs.container.focus());
    },
    methods: {
        closeModal(onclose) {
            if (onclose) {
                this.onclose = onclose;
            }
            if (this.onclose) {
                this.onclose();
            }
            this.$parent.modalOpen = !this.$parent.modalOpen;
        },
    },
};
</script>

<style lang="scss" scoped>

.modal-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.3);

    > .modal-container {
        background: $sovis-white;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        border-radius: 2px;
        width: 80%;
        height: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        position: absolute;
        &:focus {
            outline: none;
        }
        max-height: 80%;
    }
    &.contrato .modal-container {
        overflow-y: auto;
    }
    &.select-lps-modal .modal-container {
        height: 80%;
    }
}
.confirmation-window {
    .modal-container {
        width: 20%;
    }
}

@media only screen and (max-width: 760px) {
    .confirmation-window {
        .modal-container {
            width: 70%;
        }
    }
}
</style>
